<template>
	<div class="nav" @click="show=false">
		<div class="navbar-collapse-menu">

			<!--LOGO GO-->
			<div class="logo">
				<a href="./">
					<img class="pic img-responsive" src="@/assets/img/logo.png" />
				</a>
			</div>

			<!--头部导航 GO-->
			<div class="menu text-right">
				<!--天气 GO-->
				<div class="weather text-uppercase">
					

					<div class="lang">
						<label class="pointer" @click="toggle('CN')" :class="lang=='CN' ? 'lang_active' : ''">cn</label>
						|
						<label class="pointer" @click="toggle('EN')" :class="lang=='EN' ? 'lang_active' : ''">en</label>
					</div>
					
					<div class="cont">
						<label class="time">{{week || ''}}</label>
						<img class="icon_f img-responsive" src="@/assets/img/location.png" />
						<span class="city">{{LocationProvince}}-{{LocationCity}}</span>
						<!-- <img class="icon_f img-responsive" src="@/assets/img/sun.png" /> -->
						<span class="type"></span>
						<span class="low"></span>℃ 
						<span class="high"></span>风向
						<span class="wind"></span>级
					</div>
					
				</div>

				<div class="nav-panel">
					<!--一级导航 GO-->
					<div class="nav_span pointer pointers css3" :class="current==index ? 'active' :''"
						v-for="(item,index) in firstNav" @click="go(item,index)">
						{{lang=='CN' ? item.cn_name : item.en_name}}

						<!--二级导航 GO-->
						<!-- <div class="sub-mask css3" v-if="item.cn_name!='首页' && item.children.length>0 "  @mouseover="hidemask"></div> -->
						<div class="subnav css3" v-if="item.cn_name!='首页' && item.children.length>0 ">
							<ul>
								<li v-for="(ite,ind) in item.children" @click.stop="next_go(item,ind)">
									<span class="css3">{{lang=='CN' ? ite.cn_name : ite.en_name}}</span>
								</li>
							</ul>
						</div>
					</div>

					<!--搜索 GO-->
					<div v-if="!show" @click.stop="searchShow" class="search">{{lang=='CN' ?'搜索':'search'}}</div>
					<span v-if="show" class="search-hover css3 show" @click.stop="searchShow">
						<div style="margin-top: 5px;">
							<el-input placeholder="请输入内容" v-model="keyword" class="input-with-select">
								<el-select @change.stop="change" style="width:90px;" v-model="selectText" slot="prepend"
									placeholder="请选择">
									<el-option v-for="item in options" :key="item.value" :label="item.label"
										:value="item.value" />
								</el-select>
								<el-button slot="append" icon="el-icon-search" @click.stop="search"></el-button>
							</el-input>
						</div>
					</span>
				</div>
			</div>
		</div>
	</div>

</template>
<script src="https://api.map.baidu.com/api?v=3.0&ak=8h65T6bNlVxBl4paTrgqO3YWd1X2jrg2"></script>
<script type="text/javascript" src="https://webapi.amap.com/maps?v=1.3&key=8h65T6bNlVxBl4paTrgqO3YWd1X2jrg2key">
</script>
<script>
	// import BMap from 'bmap'

	import {
		myBMap
	} from '@/utils/myBMap.js' //上面定义的js文件
	export default {
		name: "Header",
		components: {
			myBMap
		},
		data() {
			return {
				gotos: '/',
				firstNav: [],
				ischildren: [],
				menu: [],
				isnav: 1,
				current: localStorage.getItem('current') || 0,
				lang: localStorage.getItem('lang') || 'CN',
				week: '',
				city: '',
				AK: 'unYUepLv3cYCCur0aooMNAmj1LVZMQFv', //百度Web服务API
				key: '6c5efe99f0efe757e0378f2a588aeb67', //
				LocationProvince: "正在定位所在省", //给渲染层定义一个初始值
				LocationCity: "正在定位所在市", //给渲染层定义一个初始值
				show: false, //是否显示输入框
				keyword: '',
				selectText: '请选择',
				showmask: true,
				selectVal: 'news',
				options: [{
					value: 'news',
					label: '资讯'
				}, {
					value: 'shop',
					label: '商城'
				}],

			};
		},
		created() {
			this.keyupSubmit()
		},

		mounted() {
			var that = this;
			this.getWeek()
			if (this.$route.path == '/') {
				this.$router.push({
					name: `Home`
				}).catch(data => {})


			}
			this.$nextTick(function() {
				// that.getCity()
				this.getAdcode()
				that.getNav()
			})
		},


		methods: {
			keyupSubmit() {
				document.onkeydown = (e) => {
					let _key = window.event.keyCode;
					if (_key === 13) {
						this.search();
					}
				};
			},
			//获取导航
			getNav() {
				let data = {
					isnav: this.isnav
				}
				this.$axios.get("/api/jx/channel_list", {
					params: data
				}).then((res) => {
					this.firstNav = res.data.data
				}).catch(err => {})

			},
			searchShow() {
				this.show = true
			},

			change(even) {
				this.selectVal = even
			},

			search() {
				if (this.$route.path == '/search') {
					this.$emit(`refreshSearch`, this.selectVal, this.keyword);
					return
				}
				this.$router.push({
					path: `search`,
					query: {
						type: this.selectVal,
						keyword: this.keyword
					}
				})
			},
			next_toggle(index) {
				this.$emit(`toggleNext`, index);
			},
			toggle(str) {
				localStorage.setItem('lang', str)
				this.lang = str
				this.$emit(`toggleLang`, str);
			},
			hidemask() {
				this.showmask = false
			},
			getCity() {
				let that = this
				let myCity = new BMap.LocalCity();
				myCity.get(function(data) {
					that.city = data.name
					that.getWeather()
				});
			},
			getWeek() {
				let myDate = new Date;
				let year = myDate.getFullYear(); //获取当前年
				let mon = myDate.getMonth() + 1; //获取当前月
				let date = myDate.getDate(); //获取当前日
				let week = myDate.getDay();
				let weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
				this.week = year + "/" + mon + "/" + date + " " + weeks[week]
			},



			getAdcode() {

				this.$axios.get('https://restapi.amap.com/v3/ip?key=6c5efe99f0efe757e0378f2a588aeb67').then(res => {
					this.getWeather(res.data.adcode)
					this.city=res.data.province+res.data.city
					
				}).catch(err => {
					console.log(err)
				})
			},


			getWeather(code) {
				let parmas = {
					type: 'weather/weatherInfo',
					version: 'v3',
					key: this.key,
					city: 10010
				}
				this.$axios.get('https://restapi.amap.com/v3/weather/weatherInfo?city=' + code +
					'&key=6c5efe99f0efe757e0378f2a588aeb67').then(res => {
					$(".city").html(this.city);
					$(".type").html(res.data.lives[0].weather);
					$(".low").html(res.data.lives[0].temperature_float);
					$(".high").html(res.data.lives[0].winddirection);
					$(".wind").html(res.data.lives[0].windpower);
					
				}).catch(err => {
					console.log(err)
				})
			},

			go(item, index) {
				localStorage.setItem('current', index)
				switch (item.cn_name) {
					case "首页":
						this.$router.push({
							name: 'Home'
						}).catch(data => {})
						// this.$router.push({name:'Home',query: { parent_id:item.id }})
						break;
					case "集团概况":
						this.$router.push({
							name: 'Group_overview',
							query: {
								parent_id: item.id
							}
						}).catch(data => {})
						break;
					case "核心板块":
						this.$router.push({
							name: 'Coreplate',
							query: {
								parent_id: item.id
							}
						}).catch(data => {})
						break;
					case "新闻中心":
						this.$router.push({
							name: 'New_list',
							query: {
								parent_id: item.id
							}
						}).catch(data => {})
						break;
					case "品牌项目":
						this.$router.push({
							name: 'Brand_project',
							query: {
								parent_id: item.id
							}
						}).catch(data => {})
						break;
					case '党群公益':
						this.$router.push({
							name: 'Dqgy',
							query: {
								parent_id: item.id
							}
						}).catch(data => {})
						break;
					case "发展大事记":
						this.$router.push({
							name: 'Fzmemorabilia',
							query: {
								parent_id: item.id
							}
						}).catch(data => {})
						break;
					default:

				}
			},

			next_go(item, ind) {
				switch (item.cn_name) {
					case "首页":
						localStorage.setItem('current', 0)
						if (this.$route.path == '/') {
							$(window).scrollTop($('.brand-project').offset().top)
							return
						}
						this.$router.push({
							name: 'Home',
							query: {
								parent_id: item.id,
								nextStr: item.children[ind].cn_name
							}
						}).catch(data => {})
						// this.$router.push({name:'Home',query: { parent_id:item.id }})
						if (item.children[ind].type == 'link') {
							window.location.href = item.children[ind].outlink
							return
						}
						break;
					case "集团概况":
						localStorage.setItem('current', 1)
						if (item.children[ind].type == 'link') {
							window.location.href = item.children[ind].outlink
							return
						} else {
							if (this.$route.path == '/group_overview') {
								this.next_toggle(ind)
							} else {
								this.$router.push({
									name: 'Group_overview',
									query: {
										parent_id: item.id
									}
								}).catch(data => {})
							}
						}
						break;
					case "核心板块":
						localStorage.setItem('current', 2)
						if (item.children[ind].type == 'link') {
							window.location.href = item.children[ind].outlink
							return
						} else {
							if (this.$route.path == '/coreplate') {
								this.next_toggle(ind)
							} else {
								this.$router.push({
									name: 'Coreplate',
									query: {
										parent_id: item.id,
										curr: ind
									}
								})
							}
						}
						break;
					case "新闻中心":
						localStorage.setItem('current', 3)
						if (item.children[ind].type == 'link') {
							window.location.href = item.children[ind].outlink
							return
						} else {
							if (this.$route.path == '/new_list') {
								this.next_toggle(ind)
							} else {
								this.$router.push({
									name: 'New_list',
									query: {
										parent_id: item.id
									}
								})
							}
						}

						break;
					case "品牌项目":
						localStorage.setItem('current', 4)
						if (item.children[ind].type == 'link') {
							window.location.href = item.children[ind].outlink
							return
						} else {
							if (this.$route.path == '/brand_project') {
								this.next_toggle(ind)
							} else {
								this.$router.push({
									name: 'Brand_project',
									query: {
										parent_id: item.id
									}
								})
							}
						}
						break;
					case '党群公益':
						localStorage.setItem('current', 5)
						if (item.children[ind].type == 'link') {
							window.location.href = item.children[ind].outlink
							return
						} else {
							if (this.$route.path == '/dqgy') {
								this.next_toggle(ind)
							} else {
								this.$router.push({
									name: 'Dqgy',
									query: {
										parent_id: item.id
									}
								})
							}
						}
						break;
					case "发展大事件":
						localStorage.setItem('current', 6)
						if (item.children[ind].type == 'link') {
							window.location.href = item.children[ind].outlink
							return
						}
						this.$router.push({
							name: 'Fzmemorabilia',
							query: {
								parent_id: item.id
							}
						})
						break;
					default:
				}
			},

		}
	};
</script>


<style lang='scss' scoped>
	.logo a:focus {
		outline: none
	}

	.nav {
		width: 100%;
		height: 200px;
		background: #FFFFFF;
		padding: relative;
		padding: 44px 30px 51px 60px;

		.navbar-collapse-menu {
			width: 100%;
			display: flex;
			justify-content: space-between;

			.logo {
				.pic {
					width: 226px;
					height: 105px;
					object-fit: contain;
				}
			}

			.menu {
				width: 100%;
				padding-left: 10%;
				margin-right: 27px;

				label {
					font-weight: initial;
				}

				.weather {
					line-height: 50px;
					font-size: 16px;
					color: #979999;
					padding: 6px 0px;
					overflow:hidden;
					.cont{ float: right;}
					.time {
						padding-right: 30px;
					}

					.city {
						padding-right: 30px;
					}

					.high {
						padding-left:10px;
					}

					.icon_f {
						position: relative;
						top: -1px;
						margin-right: 6px;
						display: inline-block;
						width: 14px;
						height: 17px;
					}
				}
				.lang{ padding-left: 30px;float: right;
				label{
					padding: 0 10px;
				}}
				.lang_active {
					color: #006170;
					font-weight: bold;
				}

				/* 一级导航 GO*/
				.nav-panel {
					display: flex;
					justify-content: space-between;

					.active {
						font-weight: bold;
					}

					.active,
					.nav_span:hover {
						border-bottom: 2px solid #006170;
						color: #006170;
					}

					.search-hover {
						opacity: 0;
						right: -100%;
						top: -5px;
						right: 0px;

						&.show {
							right: 0px;
							opacity: 1;
						}

						.el-select .el-input {
							width: 130px;
						}

						.input-with-select .el-input-group__prepend {
							background-color: #fff;
						}
					}
				}

				.search {
					line-height: 55px;
					font-size: 20px;
					padding-left: 30px;
					color: #000000;
					cursor: pointer;
					background: #ffffff url('~@/assets/img/icon-search.png') 0 center no-repeat;
				}

				/* 二级导航 GO*/
				.nav_span {
					border-bottom: 2px solid #ffffff;
					display: flex;
					align-items: center;
					color: #000000;
					height: 50px;
					font-size: 18px;

					.sub-mask {
						position: fixed;
						padding-top: 0px;
						left: 0px;
						top: 166px;
						z-index: 98;
						width: 100vw;
						height: 100vw;
						background: rgba(0, 0, 0, 0.2);
						overflow: hidden;
						display: none;

					}


					&:hover .sub-mask {
						display: block;
					}

					.subnav.hide,
					.sub-mask.hide {
						height: 0 !important;
						transition: all 0.3s ease 0s;
						-webkit-transition: all 0.3s ease 0s;
						-moz-transition: all 0.3s ease 0s;
						-o-transition: all 0.3s ease 0s;
					}

					.subnav {
						position: absolute;
						padding-top: 0px;
						left: 0px;
						top: 166px;
						z-index: 99;
						width: 100vw;
						height: 0px;
						background: #ffffff;
						overflow: hidden;


						ul {
							width: 1400px;
							margin: 0 auto !important;
							overflow: hidden;
							text-align: center;

							li {
								width: calc(20% - 30px);
								height: 60px;
								line-height: 60px;
								overflow: hidden;
								margin: 0 30px 0 0px;
								cursor: pointer;
								position: relative;
								color: #006170;
								border-bottom: 1px solid #E6E6E6;
								text-align: center;
								display: inline-block;

								&::after {
									content: '';
									position: absolute;
									display: block;
									width: 1px;
									height: 25px;
									right: 0;
									top: 17px;
									z-index: 1;
									background: #E6E6E6;
								}

								span {
									position: relative;
									display: block;
									width: 100%;
									height: 100%;
									background: url('~@/assets/img/icon-right.png') center right no-repeat;

									&::after {
										content: '';
										position: absolute;
										display: block;
										width: 100%;
										height: 100%;
										left: -100%;
										top: 0px;
										z-index: -1;
										background: #f0f4f5;
										transition: all 0.3s ease 0s;
										-webkit-transition: all 0.3s ease 0s;
										-moz-transition: all 0.3s ease 0s;
										-o-transition: all 0.3s ease 0s;
									}
								}

								&:hover span::after {
									left: 0;
									transition: all 0.3s ease 0s;
									-webkit-transition: all 0.3s ease 0s;
									-moz-transition: all 0.3s ease 0s;
									-o-transition: all 0.3s ease 0s;
								}

								&:last-child {
									margin-right: 0px;

								}

								&:last-child::after {
									display: none;

								}

								&:hover {
									border-bottom: 1px solid #ffffff;
								}
							}
						}
					}

					&:hover .subnav {
						height: 160px;
						padding-top: 30px;
					}
				}
			}
		}
	}

	/* 鼠标效果 GO*/
	.pointer {
		cursor: pointer;
	}

	.pointers:hover {
		background: transparent;
	}
</style>
